import React from "react"
import {
  FaGithub,
  FaRegHandshake,
  FaGoogle,
  FaSpaceShuttle,
  FaMoneyCheck,
  FaServer,
} from "react-icons/fa"
const data = [
  {
    id: 1,
    icon: <FaGithub className="service-icon" />,
    title: "Marketing Consulting",
    text: `We guide you through the pipelines that generate new marketing ideas with higher potential and lower risk.`,
  },
  {
    id: 2,
    icon: <FaRegHandshake className="service-icon" />,
    title: "Business Partners",
    text: `We belive in building great partnerships not acquiring clients. We treat your business like our own`,
  },
  {
    id: 3,
    icon: <FaGoogle className="service-icon" />,
    title: "Business Boosting",
    text: `We provide energy efficent and environmentally conservative scalable solutions to our clients to boost their business.`,
  },
  {
    id: 4,
    icon: <FaSpaceShuttle className="service-icon" />,
    title: "Creating Experiences",
    text: `adudev and our partners cover a large range of creativity platforms and digital projects with one purpose in mind, to crete experiences.`,
  },
  {
    id: 5,
    icon: <FaMoneyCheck className="service-icon" />,
    title: "Straegic approach",
    text: `based on solid stragigic framework and relevant research we create proto types not presentations for our clients to decide upon.`,
  },
  {
    id: 6,
    icon: <FaServer className="service-icon" />,
    title: "Great Support",
    text: `TAduDef is available 100% of the time for all our clients to help guide and support you to help solve you web app and marketing and branding issues.`,
  },
]

export default data
